<style scoped>
table.v-table thead th,
table.v-table tbody td {
  font-size: 10px;
  font-weight: 400;
  height: 20px;
}



.scroll-area {
  position: relative;
  margin: auto;
  border: 0px solid blue;
  width: 100%;
  height: 500px;
  padding-bottom: 70px;
}

.menu-row {
  font-size: 10px;
}

.v-btn {
  font-size: 12px;
  text-transform: capitalize;
}
.table-list {
  list-style-type: none;
}
.white-background {
  background-color: #fff;
}
</style>

<template>
<v-container fluid bg fill-height grid-list-md text-xs-left>



  <v-layout fill-height row wrap align-center class="menu-row" style="">

    <v-menu class="white-background" max-height="500" style="" v-model="tablesMenu" :close-on-content-click="false" :max-width="350" :nudge-width="200" offset-x>
      <template v-slot:activator="{ on }">
        <v-btn color="primary" flat v-on="on">
          Tables ({{ tables.size }})&nbsp;&nbsp;<v-icon>table_chart</v-icon>
        </v-btn>
      </template>

      <div style="display: block; width: 100%; padding: 10px; background-color: #fff;">
          <h3>Tables </h3>
          <div>
          <div>
            <div v-for="(table, index) in tables.results">
              <v-btn color="primary" flat v-on="on" @click="aAddFromTable(table.tablename);">
                <v-icon>add_circle</v-icon> &nbsp;&nbsp; {{ table.tablename }}
              </v-btn>
            </div>
          </div>
        </div>
      </div>
    </v-menu>

    <v-menu v-model="columnsMenu" :close-on-content-click="false" :max-width="350" :nudge-width="200" offset-x>
      <template v-slot:activator="{ on }">
        <v-btn color="primary" flat v-on="on">
          Columns &nbsp;&nbsp;<v-icon>view_column</v-icon>
        </v-btn>
      </template>

      <v-card>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="columnsMenu = false">Cancel</v-btn>
          <v-btn color="primary" flat @click="columnsMenu = false; aUpdate(dataSource);">Save</v-btn>
        </v-card-actions>
        <v-card-text>
          <v-select v-model="dataSource.options.selectedFields" item-value="value" item-text="textValue" :items="dataSource.headers" label="Select fields" multiple chips hint="Select fields to display" persistent-hint></v-select>
        </v-card-text>
      </v-card>
    </v-menu>

    <v-btn color="primary" flat v-if="dataSource.type != 'union_view'" pa-0 v-on:click="aCreateMerge(dataSource);">
      Create Merged Worksheet &nbsp;&nbsp;<v-icon>library_add</v-icon>
    </v-btn>
    <v-menu color="primary" flat v-if="dataSource.type == 'union_view'" v-model="mergedTablesMenu" :close-on-content-click="false" :max-width="350" :nudge-width="200" offset-x>
      <template v-slot:activator="{ on }">
        <v-btn color="primary" flat v-on="on" v-on:click="dataSource.loadMergedWorksheets(allDataSources);">
          Merged Worksheets
        </v-btn>
      </template>
      <v-card>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="mergedTablesMenu = false">Cancel</v-btn>
          <v-btn color="primary" flat @click="mergedTablesMenu = false; aMerge(dataSource);">Save</v-btn>
        </v-card-actions>
        <v-card-text>
          <v-select v-model="dataSource.childrenIds" item-value="id" item-text="name" :items="dataSource.listPossibleMergeDataSources" label="Merge worksheets" multiple chips hint="Select worksheets to merge." persistent-hint></v-select>
        </v-card-text>
      </v-card>
    </v-menu>
    <v-btn color="primary" flat pa-0 v-on:click="mSetAceEditor(editor); showQuery = !showQuery">
      Query &nbsp;&nbsp;<v-icon>code</v-icon>
    </v-btn>
    <v-btn color="primary" flat pa-0>
      {{ dataSource.tableName }} &nbsp;&nbsp;
    </v-btn>
    <v-tooltip z-index="250" top  v-if="dataSource.sqlError">
    <template v-slot:activator="{ on }">
    <v-icon color="red" dark v-on="on">error_outline</v-icon>
    </template>
     <span>{{ dataSource.sqlError }}</span>
    </v-tooltip>
    <v-flex pa-2 class="text-lg-right" v-if="dataSource">
      <span v-if="dataSource.loading">Updating Table</span>
      <span v-else>displaying {{ dataSource.filteredData.length }} rows of {{ dataSource.size }}</span>
    </v-flex>
    <v-flex xs12 fill-height v-show="showQuery">
      <ace-editor v-model="code" @init="editorInit" lang="sql" theme="chrome" width="100%" height="200"></ace-editor>
      <v-btn flat color="indigo" v-on="on" v-on:click="aUpdate(dataSource)">
        Run Query &nbsp; <v-icon>play_circle_filled</v-icon>
      </v-btn>
      <v-btn flat color="indigo" v-on="on" v-on:click="showQuery = false">
        Hide &nbsp;<v-icon>expand_less</v-icon>
      </v-btn>
    </v-flex>
    <v-flex xs12 fill-height>
      <div class="elevation-1">
        <div>

          <vue-perfect-scrollbar class="scroll-area" :settings="settings" :style="{ height: window.height + 'px', overflow: 'visible'}">

            <table class="v-datatable v-table theme--light">
              <thead>
                <tr>
                  <th class="column text-xs-left" v-for="(header, index) in dataSource.headers" :key="index" v-show="!dataSource.options.selectedFields.length || dataSource.options.selectedFields.includes(header.value)"> <a :title="header.value"> {{ header.text }} </a></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in dataSource.filteredData" :key="index">
                  <td v-for="(header, indexColumn) in dataSource.headers" :key="indexColumn" v-show="!dataSource.options.selectedFields.length || dataSource.options.selectedFields.includes(header.value)">{{item[header.value]}}</td>
                </tr>
              </tbody>
            </table>

          </vue-perfect-scrollbar>

        </div>
      </div>
    </v-flex>


  </v-layout>

</v-container>
</template>

<script>
/**  :pagination.sync="pagination" :rows-per-page-items="pagination.rowsPerPageItems" :total-items='totalItemCount'**/
import {
  createNamespacedHelpers
}
from 'vuex';
const {
  mapState,
  mapActions,
  mapGetters,
  mapMutations
} = createNamespacedHelpers('dataSources')
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import VueAceEditor from 'vue2-ace-editor';
import 'brace/ext/language_tools';
import 'brace/mode/sql';
import 'brace/theme/chrome';


export default {
  data: function() {
    return {
      on: false,
      editor: null,
      showQuery: false,
      code: "",
      columnsMenu: false,
      tablesMenu: false,
      mergedTablesMenu: false,
      pagination: {
        rowsPerPageItems: [20, 40, 60]
      },
      settings: {
        maxScrollbarLength: 60
      },
      window: {
        width: 0,
        height: 0
      }
    };
  },
  created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    ...mapActions(['aUpdate', 'aDelete', 'aMerge', 'aCreateMerge', 'aAddFromTable']),
    ...mapMutations(['mSetAceEditor']),
    editorInit: function(editor) {
      this.editor = editor;
      editor.setOptions({
        enableBasicAutocompletion: true
      });
      // this.code = this.dataSource.query;
      this.mSetAceEditor(editor);
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight - 200;
    }
  },
  computed: {
    ...mapState(['types', 'dataSources', 'dataSource', 'allDataSources', 'tables']),
    totalItemCount() {
      return this.dataSource.data.length;
    }
  },
  components: {
    'vue-perfect-scrollbar': VuePerfectScrollbar,
    'ace-editor': VueAceEditor
  }
}
</script>
